<template>
  <div class="accordion flex flex-col overflow-hidden px-3 pb-5 absolute right-0 top-0 z-50">
      <div v-show="!active" class="py-0 text-xs w-full z-30">
          <a 
            class="tab__link p-0 no-underline flex border-2 border-transparent flex-row-reverse content-center items-center transition delay-1000 cursor-pointer"
            @click="active = !active"
            >
              <div v-if="icon" class="pl-0 pr-1"><i aria-hidden="true" class="material-icons leading-tight">{{icon}}</i></div>
              <div  class="font-bold md:pl-2 uppercase w-full md:w-auto text-right">{{title}}</div>
              <div v-if="description" class="font-bold flex-1 pl-2 w-full md:w-auto md:px-3 uppercase">{{description}}</div>
          </a>
      </div>
      <transition name="drop">
        <div class="w-full bg-white shadow-lg border-2 border-gray-200 rounded-lg p-2 lg:p-4 z-20 defaultstyles" v-if="active" v-click-outside="onClickOutside">
          <div class="tab__link p-0 no-underline flex border-2 border-transparent flex-row-reverse content-center items-center transition delay-1000 cursor-pointer bg-red-100 rounded-t-lg border-gray-300 hover:bg-red-200 border-b-0 -mx-2 -mt-2 lg:-mx-4 lg:-mt-4 text-sm" @click="active = !active">
            <div class="pl-0 pr-1 text-red-800"><i aria-hidden="true" class="material-icons leading-tight">cancel</i></div>
            <div  class="font-bold md:pl-2 uppercase w-full md:w-auto text-red-800 text-right">Close</div>
            <div class="font-bold flex-1 pl-2 w-full md:w-auto md:px-3 uppercase text-red-900">Tutorial</div>
          </div>
          
          <slot />
          
          <div class="text-xs flex flex-row items-center border-t border-gray-300 mt-3 -mb-2">
            <div class="text-sm cursor-pointer mr-auto" @click="active = !active">
              <div class="inline-block px-0 text-red-800"><i aria-hidden="true" class="material-icons leading-tight align-middle">cancel</i></div>
              <div  class="inline-block font-bold uppercase md:w-auto text-red-800">Close</div>
            </div>
            <div class="w-auto">
              <a v-if="help_link" :href="help_link" target="_blank">Help & FAQ</a>
              <template v-if="help_link"> | </template>
              <a v-if="contact_form" :href="contact_form" target="_blank">Contact</a>
              <a v-else-if="contact_email" :href="'mailto:' + contact_email">Contact</a>
              <template v-if="support_phone "> | </template>
              <template v-if="support_phone"><em>Call or Text Us!</em> {{ support_phone }}</template>
            </div>
          </div>
          
        </div>     
      </transition>     
  </div>
</template>
}
<script>
import vClickOutside from 'v-click-outside'

export default {

  props: {
    title: {
      default: 'Help',
    },
    icon: {
      default: 'help',
    },
    description:'',
    isopen: {
      default: false,
    },
    support_phone: '',
    contact_form: '',
    contact_email: '',
    help_link: '',    
  },
  
  directives: {
    clickOutside: vClickOutside.directive
  },
  
  methods: {
    onClickOutside (event) {
        this.active = !this.active
    },
  },
  
  data () {
  return {
      active: this.isopen,
    }
  },
}
</script>
